module.exports = {"pathContext":{"slug":"/en/protections-coverages/","langKey":"en"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/en-protections-coverages.json
// module id = 1180
// module chunks = 144388295671145